<template>
	<v-tab-item>
		<v-card flat>
			<h3 class="text-h6 font-weight-bold">変更履歴</h3>
			<table width="100%" class="mt-2 show-dialog-table" v-if="orderIndividualInfo.order_individual_info_fixes.length">
				<tbody v-for="fix in orderIndividualInfo.order_individual_info_fixes" :key="fix.id">
					<ShowDetailRecord :columnName="'変更者'" :value="fix.user.full_name" />
					<ShowDetailRecord
						:columnName="'変更日時'"
						:value="common.formatDateTime(fix.created_at)"
					/>
					<ShowDetailRecord :columnName="'変更した項目名'" :value="columnName(fix)" />
					<ShowDetailRecord :columnName="'変更前の値'" :value="value(fix)" />
					<ShowDetailRecord
						:columnName="'変更理由'"
						text
						:value="fix.reason"
						:showEditBtn="fix.user_id == $store.getters['auth/authData'].id"
						@open-edit-dialog="openEditDialog(fix.id)"
					/>
					<tr height="8px" />
				</tbody>
			</table>
			<p v-else>
				現在、変更履歴はありません。
			</p>
		</v-card>

		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-toolbar dark color="primary" dense flat>
					<v-toolbar-title class="white--text">変更理由修正</v-toolbar-title>
				</v-toolbar>
				<v-form v-model="valid" ref="form" class="pa-2">
					<v-textarea
						class="mt-4"
						label="変更理由"
						:rules="[rules.required]"
						outlined
						dense
						v-model="reason"
					/>
					<v-card-actions>
						<v-row no-gutters>
							<v-col cols="0" sm="3" />
							<v-col cols="12" sm="6">
								<v-row no-gutters justify="center">
									<v-btn color="secondary" @click="submitForm" :disabled="!valid">
										<v-icon class="mr-1">mdi-pencil</v-icon>
										登録する
									</v-btn>
								</v-row>
							</v-col>

							<v-col cols="0" sm="3">
								<v-row no-gutters justify="end">
									<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
								</v-row>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</v-tab-item>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		order_individual_info: {
			type: null,
			required: false,
		},
		columnNames: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			selectedId: null,
			reason: null,
			dialog: false,
			valid: false,
			rules,
			common,
		}
	},
	methods: {
		openEditDialog(id) {
			this.selectedId = id
			this.dialog = true
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/order_individual_info_fixes/${this.selectedId}`
			axios
				.put(url, { order_individual_info_fix: { reason: this.reason } }, { headers })
				.then((res) => {
					let fix = this.order_individual_info.order_individual_info_fixes.find(
						(o) => o.id == this.selectedId
					)
					const i = this.order_individual_info.order_individual_info_fixes.indexOf(fix)
					if (i == -1) {
						this.$store.dispatch("setFlash", {
							type: "alert",
							text: "変更は完了しましたが、画面反映時にエラーが発生しました。",
						})
						return
					}
					fix.reason = res.data.reason
					this.order_individual_info.order_individual_info_fixes[i] = fix
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "変更を保存しました。",
					})
					this.dialog = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		columnName(fix) {
			let model = null
			if (fix.fix_target_type) {
				model = this.columnNames[fix.fix_target_type]
			} else {
				model = this.columnNames.order_individual_info
			}
			return model[fix.changed_column]
		},
		value(fix) {
			if (fix.data_type == "boolean") {
				return common.returnMaruBatsu(fix.value)
			} else if (fix.data_type == "date") {
				if (!fix.value) return null
				return common.formatDate(fix.value)
			} else if (fix.data_type == "time") {
				if (!fix.value) return null
				return common.formatTime(fix.value)
			} else if (fix.data_type == "datetime") {
				if (!fix.value) return null
				return common.formatDateTime(fix.value)
			} else if (fix.data_type == "target") {
				return fix.value?.name
			} else {
				return fix.value
			}
		},
	},
	computed: {
		orderIndividualInfo: {
			get() {
				return this.order_individual_info
			},
			set(newVal) {
				return this.$emit("update:order_individual_info", newVal)
			},
		},
	},
}
</script>